import React from 'react';
import { useTranslation } from 'react-i18next';
import { XStack, YStack } from 'tamagui';

import { WidgetCard, SkeletonBox } from '../../../components/common';

export const WeatherHighLowCardSkeleton = () => {
  const { t } = useTranslation();

  return (
    <WidgetCard
      title={t('weather.todayHighLow')}
      isDraggable={false}
      dragHandleProps={null}
      error={false}
      gap="$3.5">
      <YStack gap="$3.5" justifyContent="space-between" flex={1}>
        <XStack width="100%" justifyContent="space-between" alignItems="center">
          <YStack gap="$2">
            <SkeletonBox height={60} width={120} />
            <SkeletonBox height={28} width={100} />
          </YStack>
          <SkeletonBox height={119} width={119} borderRadius="$6" />
        </XStack>

        <YStack
          backgroundColor="$transparentBorder"
          padding="$5"
          borderRadius="$6"
          gap="$4"
          height="183px"
          justifyContent="center">
          <XStack justifyContent="space-between" alignItems="center" width="100%">
            <SkeletonBox height={24} width={60} />
            <SkeletonBox height={24} width={50} />
          </XStack>
          <XStack justifyContent="space-between">
            <SkeletonBox height={24} width={60} />
            <SkeletonBox height={24} width={50} />
          </XStack>
        </YStack>
      </YStack>
    </WidgetCard>
  );
};
